const SESSION_KEY = "mangusta24_session_token";

export function getSessionToken() {
  try {
    const token = window.localStorage.getItem(SESSION_KEY) || "";
    return /^[a-f0-9]{64}$/.test(token) ? token : "";
  } catch (error) {
    return "";
  }
}

export function setSessionToken(token) {
  if (!/^[a-f0-9]{64}$/.test(String(token || ""))) return false;
  try {
    window.localStorage.setItem(SESSION_KEY, token);
    return true;
  } catch (error) {
    return false;
  }
}

export function clearSessionToken() {
  try {
    window.localStorage.removeItem(SESSION_KEY);
  } catch (error) {
    // The in-memory session is still cleared when storage is unavailable.
  }
}



// WEBPACK FOOTER //
// ./src/utils/sessionStorage.js